import React, { useEffect, useState } from "react";
import { Collapse, Dropdown } from "react-bootstrap";
import dayjs from "dayjs";
import { BiComment, BiCommentCheck, BiExpandAlt } from "react-icons/bi";
import { BsSortUp } from "react-icons/bs";
import { MdFilterList, MdOutlineDeleteOutline } from "react-icons/md";
import { FaXmark } from "react-icons/fa6";
import InboxChats from "../../InboxManagement/InboxChats";
import { inboxServices } from "../../../APIServices/SitePilotManagement/inboxServices";
import Swal from "sweetalert2";

const ContactConversations = ({ inboxId, currentUserData }) => {
  const [expandedId, setExpandedId] = useState(null);

  const [sessions, setSessions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [inboxData, setInboxData] = useState("");
  const [messages, setMessages] = useState([]);
  const [inboxloader, setInboxLoader] = useState(false);

  const getConversationBasedonInboxId = async () => {
    setLoader(true);
    const data = await inboxServices.getConversationBasedonInboxId(inboxId);
    setSessions(buildConversationTimeline(data?.data || []));
    setLoader(false);
  };

  const deleteSession = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to permanent delete this session?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.inboxId = inboxData?.inboxId
        userData.sessionId = inboxData?.sessionId
        let data = await inboxServices.deleteSession(userData)
        if (data?.statusCode === 200) {
          getConversationBasedonInboxId();
        }
      }
    });
  };

  const getSingleInbox = async (inboxId, sessionId) => {
    setInboxLoader(true)
    let data = await inboxServices.getSingleInbox(inboxId, sessionId);
    const inbox = data?.data || {};
    const msgs = inbox?.messages || [];
    setInboxData(inbox);
    setMessages(msgs);
    setInboxLoader(false)
  };

  const buildConversationTimeline = (sessions) => {
    return sessions.map((item) => {
      const date = dayjs(item.startedDT);
      return {
        sessionId: item.sessionId,
        inboxId: item.inboxId,
        dateGroup: date.format("DD MMM YYYY"),
        time: date.format("hh:mm A"),
        type: item.type === "liveChat" ? "Chat Session" : "Ticket Session",
        chatStatus:
          item.chatStatus === "open"
            ? "Open"
            : item.chatStatus === "browsing"
              ? "Browsing"
              : "Closed",
        answeredStatus:
          item.answered
            ? "Answered"
            : "Missed",
        sessionStatus:
          item.sessionStatus === "open"
            ? "Open"
            : "Closed",
        preview: item.firstMessage,
      };
    });
  };

  useEffect(() => {
    if (inboxId) {
      getConversationBasedonInboxId();
    }
  }, [inboxId]);

  return (
    <div className="preview-block">
      <div className="timeline-wrapper">
        <div className="timeline-header">
          <div className="preview-switcher p-0" style={{ zIndex: 1 }}>
            <Dropdown align="end">
              <Dropdown.Toggle className="profile-btn px-2 border">
                <MdFilterList size={12} /> Filter
              </Dropdown.Toggle>
              <Dropdown.Menu className="profile-menu shadow-sm">
                {["Activity", "Agent", "Tag", "Created", "Updated"].map(
                  (item) => (
                    <Dropdown.Item key={item} className="menu-item">
                      {item}
                    </Dropdown.Item>
                  )
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <button className="timeline-btn border px-2">
            <span>Created on</span>
            <BsSortUp size={12} />
          </button>
        </div>
        {sessions.map((item, index) => {
          const showDate =
            index === 0 ||
            sessions[index - 1].dateGroup !== item.dateGroup;
          const isExpanded = expandedId === item.sessionId;
          return (
            <React.Fragment key={index}>
              {showDate && (
                <div className="timeline-date">{item.dateGroup}</div>
              )}
              <div className="timeline-item">
                <div title={`Chat Status: ${item?.chatStatus}\nAnswered Status: ${item?.answeredStatus}`} className={`timeline-icon ${item?.chatStatus === "Browsing" ? "bg-warning-subtle text-warning" : item?.chatStatus === "Open" ? "bg-danger-subtle text-danger" : "bg-success-subtle text-success"}`}>
                  {item?.answeredStatus === "Missed" ?
                    <BiComment />
                    :
                    <BiCommentCheck />
                  }
                </div>
                <Collapse in={isExpanded}>
                  <div className="w-100">
                    <InboxChats
                      setExpandedId={setExpandedId}
                      category={inboxData?.type}
                      inboxData={inboxData}
                      currentUserData={currentUserData}
                      getSingleInbox={getSingleInbox}
                      getInboxList={() => { }}
                      setSessionId={() => { }}
                      sessionId={item?.sessionId}
                      type="quickChat"
                      messages={messages || inboxData?.messages || []}
                      setMessages={setMessages}
                    />
                  </div>
                </Collapse>
                {!isExpanded && (
                  <div className="timeline-card">
                    <div className="timeline-card-header">
                      {(item.sessionStatus === "Open" && item.chatStatus === "Open") ?
                        <strong>Current Chat Session</strong>
                        :
                        <>
                          <strong>{item.type}</strong>
                          <span className="muted">{item.sessionStatus}</span>
                        </>
                      }
                      <time>{item.time}</time>
                    </div>
                    <p className="timeline-text">
                      {item.preview ? item.preview.split("\n").map((l, i) => (
                        <div key={i}>{l}</div>
                      )) :
                        <div className="text-muted">No messages yet</div>
                      }
                    </p>
                    <button
                      className="timeline-action"
                      title={isExpanded ? "Close" : "Expand"}
                      style={{ right: 40 }}
                      onClick={() => {
                        getSingleInbox(item?.inboxId, item?.sessionId)
                        setExpandedId((prev) => (prev === item.sessionId ? null : item.sessionId))
                      }}
                    >
                      {isExpanded ? <FaXmark /> : <BiExpandAlt />}
                    </button>

                    <button onClick={deleteSession} className="timeline-action text-danger" title="Delete">
                      <MdOutlineDeleteOutline />
                    </button>
                  </div>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ContactConversations;
